import { SubscriptionPlanType } from '../../../ReduxStorage/SubscriptionPlans/constants';
import {
  UserSubscriptionStripeConnectStatus,
  UserSubscriptionPlanBillingCycle,
  UserSubscriptionPlanBillingMethod,
  UserSubscriptionPlanStatus,
  RevenueShare,
} from '../../../ReduxStorage/UserSubscriptionPlans/constants';
import { Currency } from '../../utilities/currency-list';

export type UserSubscriptionPlanDetail = {
  name?: string;
  status: UserSubscriptionPlanStatus;
  nextPayment: string;
  price?: number;
  billingCycle?: UserSubscriptionPlanBillingCycle;
  paymentInterval?: 'month' | 'year';
  currency?: Currency;
  type: SubscriptionPlanType;
  educatorLimit?: number;
  learnerLimit?: number;
  portalLimit: number | null;
  billingMethod: UserSubscriptionPlanBillingMethod;
  cardType?: string;
  cardholderName?: string;
  expiryDate?: string;
  cardNumber?: string;
  email?: string;
  cancelAtPeriodEnd?: boolean;
  stripeConnectStatus: UserSubscriptionStripeConnectStatus;
  revenueShare: RevenueShare | null;
};

export enum TabOptionTypes {
  ACCOUNT_USAGE = 'ACCOUNT_USAGE',
  BILLING_DETAILS = 'BILLING_DETAILS',
  CHANGE_PLAN = 'CHANGE_PLAN',
  MANAGE_USERS = 'MANAGE_USERS',
  MANAGE_INSTITUTION = 'MANAGE_INSTITUTION',
  COURSE_MARKETPLACE = 'COURSE_MARKETPLACE',
}

export type TabOption = {
  key: TabOptionTypes;
  label: string;
  hasPermission: boolean;
  onClick?: () => void;
};

export type TabOptions = TabOption[];
